
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.391 2.258a9.911 9.911 0 00-.782 0 .752.752 0 00-.297.016C6.248 2.627 2.25 6.846 2.25 12c0 5.154 3.998 9.373 9.062 9.726.096.025.197.03.297.016a9.97 9.97 0 00.782 0c.1.015.2.009.297-.016 5.064-.353 9.062-4.572 9.062-9.726 0-5.154-3.998-9.373-9.062-9.726a.752.752 0 00-.297-.016zm-.469 1.492a8.45 8.45 0 01.156 0 16.249 16.249 0 011.811 4.5h-3.778a16.252 16.252 0 011.811-4.5zm-2.093 6h4.342a16.257 16.257 0 010 4.5H9.83a16.249 16.249 0 010-4.5zm-1.514 4.5a17.75 17.75 0 010-4.5H4.061A8.256 8.256 0 003.75 12c0 .78.108 1.535.31 2.25h4.255zm-3.665 1.5h3.923c.32 1.482.83 2.92 1.518 4.278A8.266 8.266 0 014.65 15.75zm5.46 0h3.78a16.249 16.249 0 01-1.812 4.5 6.76 6.76 0 01-.156 0 16.252 16.252 0 01-1.811-4.5zm5.317 0c-.32 1.482-.83 2.92-1.518 4.278a8.266 8.266 0 005.441-4.278h-3.923zm4.512-1.5A8.26 8.26 0 0020.25 12a8.26 8.26 0 00-.31-2.25h-4.255a17.738 17.738 0 010 4.5h4.254zM10.091 3.972A17.75 17.75 0 008.573 8.25H4.65a8.266 8.266 0 015.441-4.278zm5.336 4.278h3.923a8.266 8.266 0 00-5.442-4.278 17.746 17.746 0 011.52 4.278z"}})])
          )
        }
      }
    